(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["sh-estimation"] && !Shopify.designMode) return;
  try {
    (function () {
  if (window.__shEstimInit) return;
  window.__shEstimInit = true;
  function fill() {
    document.querySelectorAll('[data-sh-estim]').forEach(function (box) {
      var scope = box.closest('.product-information, section') || document;
      var parts = [];
      scope.querySelectorAll('input[type="radio"]:checked').forEach(function (r) { if (r.value) parts.push(r.value); });
      var cfg = box.querySelector('[data-sh-estim-config]');
      if (cfg) cfg.value = parts.join(' / ') || 'configuration par défaut';
      var priceEl =
        scope.querySelector('.group-block-content product-price .price') ||
        scope.querySelector('product-price .price');
      var pr = box.querySelector('[data-sh-estim-price]');
      if (pr && priceEl) pr.value = (priceEl.textContent || '').trim() + ' TTC départ usine, hors transport';
    });
  }
  document.addEventListener('change', function () { setTimeout(fill, 150); });
  document.addEventListener('submit', function (e) {
    if (e.target && e.target.id === 'sh-estim-form') fill();
  }, true);
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', fill); } else { fill(); }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["sh-gravure"] && !Shopify.designMode) return;
  try {
    (function () {
  if (window.__shGravureInit) return;
  window.__shGravureInit = true;

  function realForm(scope) {
    // Plusieurs formulaires /cart/add peuvent coexister (ex. mensualites) :
    // le vrai est celui qui contient le bouton d'ajout au panier.
    var forms = scope.querySelectorAll('form[data-type="add-to-cart-form"], form[action*="/cart/add"]');
    for (var i = 0; i < forms.length; i++) {
      if (forms[i].querySelector('.add-to-cart-button, button[name="add"], button[type="submit"]')) return forms[i];
    }
    return forms[0] || null;
  }

  function refresh() {
    document.querySelectorAll('[data-sh-gravure]').forEach(function (box) {
      var scope =
        box.closest('.product-information, [data-testid="product-information"], .quick-add-modal__content, section') ||
        document;
      var selected = false;
      scope.querySelectorAll('input[type="radio"]:checked, select').forEach(function (el) {
        if (el.value && el.value.indexOf('Avec gravure') !== -1) selected = true;
      });
      var input = box.querySelector('.sh-gravure__input');
      var form = realForm(scope);
      if (form && input) {
        var mirror = form.querySelector('.sh-gravure-mirror');
        if (!mirror) {
          mirror = document.createElement('input');
          mirror.type = 'hidden';
          mirror.name = 'properties[Nom à graver]';
          mirror.className = 'sh-gravure-mirror';
          form.appendChild(mirror);
        }
        mirror.value = input.value;
        mirror.disabled = !selected;
        box.__shForm = form;
      }
      if (input) {
        box.hidden = !selected;
        if (!selected) input.value = '';
        box.__shSelected = selected;
      }
    });
  }

  // Bloque l'ajout si "Avec gravure" sans nom
  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('.add-to-cart-button, button[name="add"]') : null;
    if (!btn) return;
    var boxes = document.querySelectorAll('[data-sh-gravure]');
    for (var i = 0; i < boxes.length; i++) {
      var box = boxes[i];
      if (box.__shSelected && box.__shForm && box.__shForm.contains(btn)) {
        var input = box.querySelector('.sh-gravure__input');
        if (input && !input.value.trim()) {
          e.preventDefault(); e.stopPropagation();
          input.focus();
          input.style.borderColor = 'var(--sh-color-accent, #b5532e)';
          return;
        }
      }
    }
  }, true);

  document.addEventListener('input', function (e) {
    if (e.target.classList && e.target.classList.contains('sh-gravure__input')) refresh();
  });
  document.addEventListener('change', function () { setTimeout(refresh, 50); });
  document.addEventListener('DOMContentLoaded', refresh);
  document.addEventListener('shopify:section:load', refresh);
  new MutationObserver(function () { setTimeout(refresh, 100); })
    .observe(document.body, { childList: true, subtree: true });
  refresh();
})();
  } catch(e) { console.error(e); }
})();

})();
